<template>
<div id="trafico-transporte">

    <v-form id="apptraficotransporte" ref="form">
        <div class="row">
            <div class="col-xs-1">
                <v-btn fab dark x-small color="green" v-on:click="addNew" title="Agregar" v-tippy>
                    <v-icon dark>add</v-icon>
                </v-btn>
            </div>
            <div class="col-xs-10"></div>
        </div>
        <div v-for="(alertas, index) in detalles" v-bind:key="index" @keyup.enter="nextTab">
            <v-row style="flex-wrap: nowrap;">
                <v-col cols="3" class="flex-grow-0 flex-shrink-0">
                    <v-autocomplete v-model="alertas.tipo_usuario" :items="tipos" :hide-no-data="true" item-text="tipo" item-value="tipo" label="Selecciona un Tipo de Usuario" :rules="[rules.required]"></v-autocomplete>

                </v-col>
                <v-col cols="4" class="flex-grow-1 flex-shrink-0">
                    <v-text-field :name="'nombre['+index+']'" label="Nombre" type="text" v-model="alertas.nombre" :rules="[rules.required]"></v-text-field>

                </v-col>
                <v-col cols="4" class="flex-grow-0 flex-shrink-1">

                    <v-text-field :name="'email['+index+']'" label="Email" type="text" v-model="alertas.email" :rules="[rules.required, rules.email]"></v-text-field>

                </v-col>
                <v-col cols="1" class="flex-grow-0 flex-shrink-1">
                    <v-btn fab dark x-small color="red" v-on:click="remove(index)" title="Eliminar" v-tippy>
                        <v-icon dark>remove</v-icon>
                    </v-btn>
                </v-col>
            </v-row>

        </div>

    </v-form>

    <p />
    <p />
    <p />

</div>
</template>

<script>
import Vue from "vue";

import {
    request
} from 'http';
import {
    mapState
} from 'vuex'
import axios from "axios";

export default {
    components: {

    },
    computed: mapState([
        'transporte_trafico'
    ]),
    methods: {
        nextTab() {
            this.$emit('nextTab', 5);
        },
        addNew: function () {
            this.detalles.push(Vue.util.extend({}, this.alertas));
        },
        remove: function (index) {
            Vue.delete(this.detalles, index);
        },
        guardar(resolve) {
            var referencia = this.$local_storage.get('referencia');
            var rfc = this.$local_storage.get('rfc');
            if (referencia != null && referencia.trim() != '') {
                const datos = {
                    rfc: rfc,
                    referencia: referencia,
                    alertas: this.detalles,
                };

                if (!this.$refs.form.validate()) {
                    this.$swal({
                        type: "info",
                        title: "Cuidado!",
                        text: 'Datos incompletos en el formulario. Favor de verificar.'
                    });
                    resolve(false);
                } else if (this.formUpdated == true) {
                    this.$root.$dialogLoader.show('Espere un momento por favor..');
                    axios({
                            method: "put",
                            url: this.URL + "actualizar/",
                            data: datos
                        })
                        .then((res) => {
                            this.$swal({
                                type: "success",
                                title: "¡Operación Exitosa!",
                                text: "Las Alertas y Notificaciones se guardaron correctamente",
                            });
                            this.$root.$dialogLoader.hide();
                            this.formUpdated = false;
                            resolve(true);
                        })
                        .catch((error) => {
                            this.$swal({
                                position: "center",
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: 'Error al guardar los datos!'
                                //showConfirmButton: false,
                            });
                            console.log(error);
                            this.cargar();
                            this.$root.$dialogLoader.hide();
                            resolve(false);
                        });
                } else {
                    resolve(true);
                }

            } else {
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: 'Primero debe guardar datos generales del tráfico'
                });
                resolve(false);
            }
        },
        cargar: function () {
            var referencia = this.$local_storage.get('referencia');
            var rfc = this.$local_storage.get('rfc');
            if (referencia != null && referencia.trim() != '') {
                var datos = {
                    rfc: rfc,
                    referencia: referencia,
                };
                this.$root.$dialogLoader.show('Espere un momento por favor..');
                axios.post(this.URL + 'obtener/', datos)
                    .then((res) => {

                        if (typeof res.data !== 'undefined') {
                            this.detalles = res.data.alertas;
                            //Si no se ha guardado antes ningún contacto, traemos los relacionados al cliente
                            if (this.detalles.length == 0)
                                this.cargarContactos();
                        }
                    })
                    .catch((err) => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Error al obtener los registros de alertas y notificaciones"
                        });
                        console.log(err.response);
                    }).then(() => {
                        this.$root.$dialogLoader.hide();
                        this.formUpdated = false;
                    });
            }
        },
        cargarContactos: function () {
            var referencia = this.$local_storage.get('referencia');
            var rfc = this.$local_storage.get('rfc');
            if (referencia != null && referencia.trim() != '') {
                var datos = {
                    rfc: rfc,
                    referencia: referencia,
                };
                axios.post(this.URL + 'obtener_contactos/', datos)
                    .then((res) => {

                        if (typeof res.data !== 'undefined') {
                            this.detalles = res.data;
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    }).then(() => {
                        this.formUpdated = true;
                    });
            }
        },
        formChanged: function (newV, oldV) {
            this.formUpdated = true;
        },

    },
    created: function () {
        this.URL = this.$hostname + 'traficos/';
        this.$root.$dialogLoader.hide();
        this.cargar();
        this.formUpdated = false;
        this.$watch('detalles', this.formChanged, {
            deep: true
        });
    },
    beforeDestroy: function () {
        this.detalles = [];
    },

    data: () => ({
        fab: false,
        formUpdated: false,
        tipos: [{
            "tipo": "Agente Aduanal"
        }, {
            "tipo": "Agente de Carga"
        }, {
            "tipo": "Transportista"
        }, {
            "tipo": "Embarcador/Consignatario"
        }, {
            "tipo": "Otro"
        }],
        loading: false,
        show_loading: false,
        URL: '',
        alertas: {
            tipo_usuario: "",
            email: "",
            nombre: ""
        },
        rules: {
            required: v => !!v || "Este campo es requerido",
            email: value => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return pattern.test(value) || "Correo electrónico no valido";
            },
        },
        detalles: []
    })
};
</script>
